import { 
  Box, 
  Typography, 
  Card, 
  CardContent, 
  Button, 
  CardActions 
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const InfoCard = ({ icon, title, description, linkText, linkTo, external = false }) => {
  return (
    <Card
      elevation={0}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        transition: 'all 0.2s',
        '&:hover': {
          boxShadow: 2,
          transform: 'translateY(-4px)'
        }
      }}
    >
      <CardContent sx={{ flexGrow: 1, pt: 4 }}>
        <Box display="flex" justifyContent="center" mb={2}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 60,
              height: 60,
              borderRadius: '50%',
              bgcolor: 'primary.light',
              color: 'primary.main',
              mb: 2
            }}
          >
            {icon}
          </Box>
        </Box>
        <Typography variant="h6" component="h3" align="center" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" align="center">
          {description}
        </Typography>
      </CardContent>
      <CardActions sx={{ justifyContent: 'center', pb: 3 }}>
        {external ? (
          <Button 
            size="small" 
            endIcon={<ArrowForwardIcon />}
            href={linkTo}
            target="_blank"
          >
            {linkText}
          </Button>
        ) : (
          <Button 
            size="small" 
            endIcon={<ArrowForwardIcon />}
            component={RouterLink}
            to={linkTo}
          >
            {linkText}
          </Button>
        )}
      </CardActions>
    </Card>
  );
};

export default InfoCard; 